export const ApiDef_PermissionProject = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map